import { createContext } from "react";
import { type BuTimeframe } from "@domain/models/Bu";

export type { BuTimeframe };

export type DbEntryVersion = {
    tfid: string;
    version: number;
};

type BuContextValue = {
    companyBuTimeframes: BuTimeframe[];
    allBuTimeframes: Omit<BuTimeframe, "defaultCategories">[];
};

export const defaultBuContextValue: BuContextValue = { companyBuTimeframes: [], allBuTimeframes: [] };

export const BuContext = createContext<BuContextValue>(defaultBuContextValue);
